import React from "react"
import { Step, StepProps, StepVariant } from "../../atoms/step"
import styled, { css } from "styled-components"
import { theme } from "../../../theme"
import { Stepper as StepperMaterial } from "@mui/material"

export interface StepperProps {
  steps: StepProps[]
  activeStep?: number
  nonLinear?: boolean
  alternativeLabel?: boolean
  padding?: string
  backgroundColor?: string
  bannerStepper?: boolean
}

export const Stepper = (props: StepperProps) => {
  const { steps, activeStep, nonLinear, alternativeLabel, padding, backgroundColor, bannerStepper, ...others } = props

  const getVariant = (index: number, variant?: StepVariant): StepVariant => {
    if (index === activeStep) return StepVariant.active
    if (nonLinear) return variant ? variant : StepVariant.inactive
    if (activeStep && index < activeStep) return StepVariant.done
    return StepVariant.inactive
  }
  return (
    <CustomStepper
      activeStep={activeStep}
      alternativeLabel={bannerStepper ? true : alternativeLabel}
      nonLinear={nonLinear}
      $padding={padding}
      $backgroundColor={backgroundColor}
      $bannerStepper={bannerStepper}
      {...others}
    >
      {steps.map((step, index) => (
        <Step
          bannerStepper={bannerStepper}
          variant={getVariant(index, step.variant)}
          label={step.label}
          key={step.key}
          bannerIcon={step.bannerIcon}
        />
      ))}
    </CustomStepper>
  )
}

const bannerStepperStyle = css`
  width: 50%;
  background-color: inherit;
  margin-top: ${theme.spacing.lx};
  padding: 0;

  .MuiStepConnector-alternativeLabel {
    top: 19px;
    right: 100%;
    left: calc(-100% + 40px);
  }

  .MuiStep-horizontal {
    padding: 0;
  }

  .MuiStepConnector-line {
    background-color: ${theme.color.primary100};
    border-color: ${theme.color.primary100};
    height: 3px;
  }
`

const CustomStepper = styled(StepperMaterial)<{
  $padding?: string
  $backgroundColor?: string
  $bannerStepper?: boolean
}>`
  ${(p) =>
    css`
      padding: ${!!p.$padding ? p.$padding : theme.spacing.lx};
    `}

  background-color:
  ${(p) => (p.$backgroundColor ? p.$backgroundColor : theme.color.white)};

  .MuiStepConnector-line {
    border-color: ${theme.color.grey5};
  }

  ${(p) => p.$bannerStepper && bannerStepperStyle}

  gap: ${theme.spacing.m};
`
